import React from "react";

const NoDataComponent = (): JSX.Element => {
    return <span>Keine Einträge gefunden</span>;
};

export default NoDataComponent;
